import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { useEffect, useRef, useState } from "react";
import "./index.css";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { useNavigate } from "react-router-dom";
import { clearLocalStorage } from "presentation/utils/localStorage";
import { httpClient } from "infra/axios/axios-api";
import ImpersonateDialog from "./ImpersonateDialog";
import { useImpersonationStore } from "presentation/stores/use-impersonation-store";
import { useRolesStore } from "presentation/stores/use-roles-list-store";

const MenuProfile = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { clearAuth, userName, userEmployee, userPermissions } = useAuthStore();
  const { isDebugMode } = useImpersonationStore();
  const { roles } = useRolesStore();
  const navigate = useNavigate();
  const [impersonateDialogVisible, setImpersonateDialogVisible] = useState(false);

  const hasDeveloperRole = roles?.some((r: any) => r.name === "Developer") || 
                           userPermissions?.some((p: any) => p.role?.name === "Developer" || p.function?.name === "Developer");
  const isDeveloper = hasDeveloperRole && !isDebugMode;

  const getFirstAndLastName = (fullName?: string | null) => {
    if (!fullName) return "";
    const parts = fullName.trim().split(" ");
    if (parts.length <= 1) return fullName;
    return `${parts[0]} ${parts[parts.length - 1]}`;
  };

  const items: any[] = [];

  if (isDeveloper && !isDebugMode) {
    items.push({
      label: "Ver como...",
      icon: "pi pi-users",
      command: () => {
        setImpersonateDialogVisible(true);
        setIsMenuOpen(false);
      }
    });
  }

  items.push({
    label: "Sair",
    icon: "pi pi-power-off",
    command: () => {
      clearAuth();
      clearLocalStorage();
      navigate("/login");
    },
  });

  const [photoUrl, setPhotoUrl] = useState<string>("");

  useEffect(() => {
    const fetchPhoto = async () => {
      const currentUrl = await useAuthStore.getState().getPhotoUrl();
      if (currentUrl && currentUrl !== photoUrl) {
        try {
          const response = await httpClient.get(
            `/assets/${currentUrl}`
          );
          setPhotoUrl(response.data.url);
        } catch (error) {
          console.error("Erro ao buscar imagem do funcionário:", error);
        }
      }
    };

    if (!photoUrl) {
      fetchPhoto();
    }
  }, [photoUrl]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  return (
    <div className="profile-group">
      <div className="profile-photo" onClick={toggleMenu}>
        <Avatar image={photoUrl || ""} className={"profile-avatar"} />
        <div className="profile-text">
          <span className="profile-name">{getFirstAndLastName(userEmployee?.name || userName)}</span>
          <span className="profile-function">
            {userEmployee?.jobTitle?.name || ""}
          </span>
        </div>
      </div>

      {isMenuOpen && (
        <div ref={menuRef} style={{ position: "absolute", zIndex: 1000, right: "10px", marginTop: "10px" }}>
          <Menu model={items} />
        </div>
      )}

      <ImpersonateDialog 
        visible={impersonateDialogVisible} 
        onHide={() => setImpersonateDialogVisible(false)} 
      />
    </div>
  );
};

export default MenuProfile;
